import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { StatisticsChartComponent } from './statistics-chart.component';

import { TranslateModule } from '@ngx-translate/core';
import { NgbCollapseModule, NgbDropdownModule, NgbModule, NgbNavModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { SharedModule } from 'src/app/_metronic/shared/shared.module';
import { CrudModule } from 'src/app/modules/crud/crud.module';
import { WidgetsModule } from 'src/app/_metronic/partials/content/widgets/widgets.module';
import { NgApexchartsModule } from 'ng-apexcharts';
import { DrilldownModalComponent } from './drilldown-modal/drilldown-modal.component';

@NgModule({
  declarations: [StatisticsChartComponent,DrilldownModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgApexchartsModule,
    TranslateModule,
    RouterModule.forChild([
      {
        path: '',
        component: StatisticsChartComponent,
      },
    ]),
    NgbModule,
    NgbNavModule,
    NgbDropdownModule,
    NgbCollapseModule,
    NgbTooltipModule,
    SweetAlert2Module.forChild(),
    CrudModule,
    WidgetsModule,
    SharedModule,
    
  ],
  exports: [StatisticsChartComponent],
})
export class StatisticsChartModule {}
